import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import VueAxios from "vue-axios";
import Storage from "vue-ls";
import VueRandomColor from "vue-randomcolor";
import Es6Promise from "es6-promise";
import VueMoment from "vue-moment";
import VueMatchHeights from "vue-match-heights";

import VueAuth from "./auth";
import DashboardPlugin from "./dashboard-plugin";

// Plugins
import App from "./App.vue";

// router setup
import routes from "./routes/routes";

// config setup
import config from "./config";

// Import filters
import { domain, count, pluralize, humanize } from "./filters";

// ES6 Promise Polyfill
Es6Promise.polyfill();

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(Storage, {
  namespace: `${config.namespace}__`, // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
});
Vue.use(VueRandomColor);
Vue.use(VueMatchHeights, {
  // disabled: [768], // Optional: default viewports widths to disabled resizing on. Can be overridden per usage
});

Vue.filter("count", count);
Vue.filter("domain", domain);
Vue.filter("pluralize", pluralize);
Vue.filter("humanize", humanize);

// configure axios
Vue.axios.defaults.baseURL = config.apiBaseUrl;
Vue.axios.defaults.headers = {
  "API-Key": config.apiKey
};

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

Vue.router = router;

Vue.use(VueAuth); // must be below 'Vue.router = router;'

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router
});
